import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Arrow, PageHero, usePageTitle } from './components';
export function LoginPage() {
    usePageTitle('Log in');
    const [runtime, setRuntime] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        let active = true;
        fetch('/runtime-config.json', { cache: 'no-store' })
            .then(async (response) => {
            if (!response.ok)
                throw new Error('Application links are not available yet.');
            return response.json();
        })
            .then(value => {
            if (!active)
                return;
            setRuntime(value);
        })
            .catch(caught => {
            if (!active)
                return;
            setError(caught instanceof Error ? caught.message : 'Application links are not available yet.');
        });
        return () => { active = false; };
    }, []);
    const patientUrl = runtime?.patientAppUrl;
    const clinicalUrl = runtime?.clinicalAppUrl;
    return _jsxs(_Fragment, { children: [_jsx(PageHero, { eyebrow: "Secure access", title: "Choose your MedAlign workspace.", body: "Patients and caregivers use the medication-safety app. Care teams use the clinical workspace to review questions, make accountable decisions, and close the loop." }), _jsxs("section", { className: "login-options", children: [_jsxs("div", { className: "container login-options__grid", children: [_jsxs("article", { className: "login-option", children: [_jsx("p", { className: "eyebrow", children: "Patients & caregivers" }), _jsx("h2", { children: "Medication-safety app" }), _jsx("p", { children: "Review your medication picture, check something new, see care-team responses, and stay connected to follow-up." }), patientUrl
                                        ? _jsxs("a", { className: "button", href: patientUrl, children: ["Patient login ", _jsx(Arrow, {})] })
                                        : _jsx("p", { className: "login-option__status", children: "Patient login is temporarily unavailable." })] }), _jsxs("article", { className: "login-option", children: [_jsx("p", { className: "eyebrow", children: "Care teams" }), _jsx("h2", { children: "Clinical workspace" }), _jsx("p", { children: "Review medication-safety cases with patient context attached, document decisions, and manage follow-through." }), clinicalUrl
                                        ? _jsxs("a", { className: "button", href: clinicalUrl, children: ["Care team login ", _jsx(Arrow, {})] })
                                        : _jsx("p", { className: "login-option__status", children: "Clinical login is temporarily unavailable." })] })] }), error ? _jsx("div", { className: "container", children: _jsx("p", { className: "login-config-note", role: "status", children: error }) }) : null] })] });
}
